import React from 'react';
import { Paper, Typography, Box, Link } from '@mui/material';
import PropTypes from 'prop-types';  // Import PropTypes

const NewsList = ({ cryptoNews }) => {
  return (
    <Paper sx={{
      maxHeight: 250,
      overflowY: 'auto',
      border: '1px solid #ccc',
      paddingX: 2,
      marginTop: 1,
      background: '#3b4054',
      color: '#dae1e3',
      borderRadius: '0.7rem'
    }}>
      {cryptoNews.map((news, index) => (
        <Box key={index} sx={{ border: '1px solid #dae1e3', borderRadius: '0.7rem', padding: 2, my: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {news.title}
          </Typography>
          <Typography variant="body1">{news.description}</Typography>
          <Typography variant="caption">Author: {news.author}</Typography>
          <Typography variant="caption" sx={{ display: 'block' }}>
            Source: {news.news_site}
          </Typography>
          <Link
            href={news.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            Read more
          </Link>
        </Box>
      ))}
    </Paper>
  );
};

// Define PropTypes for NewsList component
NewsList.propTypes = {
  cryptoNews: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    author: PropTypes.string,
    url: PropTypes.string.isRequired,
    news_site: PropTypes.string.isRequired
  })).isRequired
};

export default NewsList;
